import { Base } from "@app/controllers/base";
import "@js/plugins/select2/main.js"

export default class extends Base {
  static values = {
    config: Object,
  };
  connect() {
    this.$select = $(this.element);
    this.$select.select2({
      width: "100%",
      ...this.configValue,
    });

    // Select2 fires jQuery events, not native DOM events.
    // Re-dispatch as a native event so Stimulus data-action="change->..." listeners fire.
    // Using select2:select/unselect/clear (not "change") avoids an infinite loop —
    // "change" would be caught by jQuery again, triggering another native dispatch.
    this.$select.on("select2:select select2:unselect select2:clear", () => {
      this.element.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  disconnect() {
    if (this.$select) {
      this.$select.off("select2:select select2:unselect select2:clear");
      this.$select.select2("destroy");
    }
  }
}
